import { createAction, handleActions } from 'redux-actions';

const addDeletedProcurementItemId = createAction("SCREENS/ORDER_VIEW/ADD_DELETED_PROCUREMENT_ITEM_ID");
const clearDeletedProcurementItemIds = createAction("SCREENS/ORDER_VIEW/CLEAR_DELETED_PROCUREMENT_ITEM_IDS");

const defaultState = [];

const reducer = handleActions(
  {
    [addDeletedProcurementItemId]: (state, action) => [...state, action.payload],
    [clearDeletedProcurementItemIds]: () => defaultState,
    'RESET_ORDER_VIEW': () => defaultState,
  },
  defaultState
);

export { addDeletedProcurementItemId, clearDeletedProcurementItemIds, reducer };
